import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: '¿Necesito hacer una cita o aceptan walk-ins?',
  answer: 'Recomendamos agendar tu cita para garantizar disponibilidad y un servicio sin esperas. Sin embargo, aceptamos walk-ins según disponibilidad.'
}, {
  question: '¿Cuánto tiempo dura una sesión completa?',
  answer: 'Una sesión completa de The Full Experience dura aproximadamente 60-75 minutos. Un corte estándar toma entre 30-45 minutos dependiendo del estilo.'
}, {
  question: '¿Qué incluye The Full Experience?',
  answer: 'Incluye consulta personalizada, corte de precisión, perfilado de barba, tratamiento con toalla caliente, lavado y styling final. Es nuestra experiencia premium de principio a fin.'
}, {
  question: '¿Trabajan con todo tipo de cabello?',
  answer: 'Absolutamente. Nuestros barberos están entrenados en todas las texturas y tipos de cabello. Cada corte comienza con un análisis personalizado para lograr el mejor resultado.'
}, {
  question: '¿Cuáles son sus métodos de pago?',
  answer: 'Aceptamos efectivo, todas las tarjetas de crédito y débito, Apple Pay, Google Pay y transferencias electrónicas.'
}, {
  question: '¿Ofrecen servicios para eventos especiales?',
  answer: 'Sí, ofrecemos paquetes para bodas, graduaciones y eventos corporativos. Contáctanos para diseñar un paquete personalizado para tu grupo.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-24 md:py-32 container mx-auto px-6 md:px-12" data-id="element-66">
      <motion.div className="text-center mb-16" initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8
    }} data-id="element-67">
        <h2 className="font-serif text-4xl md:text-5xl mb-6" data-id="element-68">
          Preguntas <span className="text-gold italic" data-id="element-69">Frecuentes</span>
        </h2>
        <div className="w-24 h-[1px] bg-gold mx-auto" data-id="element-70"></div>
      </motion.div>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-71">
        {faqs.map((faq, index) => <motion.div key={index} className={`glass-card rounded-2xl overflow-hidden transition-all duration-300 ${openIndex === index ? 'border-l-4 border-l-gold bg-white/10' : 'border-l-4 border-l-transparent'}`} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.08
      }} data-id="element-72">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-white/5 transition-colors" data-id="element-73">
              <span className="font-serif text-lg text-white/90 pr-4" data-id="element-74">
                {faq.question}
              </span>
              <motion.span animate={{
            rotate: openIndex === index ? 180 : 0
          }} transition={{
            duration: 0.3
          }} className="flex-shrink-0" data-id="element-75">
                <ChevronDownIcon className="w-5 h-5 text-gold" data-id="element-76" />
              </motion.span>
            </button>
            <AnimatePresence data-id="element-77">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="overflow-hidden" data-id="element-78">
                  <div className="px-6 pb-6 text-white/60 font-light leading-relaxed border-t border-white/5 pt-4" data-id="element-79">
                    {faq.answer}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}